import { HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { projectConfig } from '../../environments/environment';
import { Observable, Observer,firstValueFrom  } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PromptCreateService {

  public apiURL: string = projectConfig.apiURL;
  public chatApiURL: string = projectConfig.chatPromptURL;
  public storedAttachments: any = [];
  promptSaveResp$ = new BehaviorSubject<any | null>(null);
  private dataSubject = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAllCate(search_text : string , user_id : number, model_id : [] , category_id : [] , sub_category_id : [] , created_by : [] , my_favourites : boolean , my_prompts : boolean,user_role : string , status:[]) {
    const bodyRequest = JSON.stringify({
      "search_text": search_text,
      "user_id": user_id,
      "my_favourites": my_favourites,
      "my_prompts": my_prompts,
      "model": model_id,
      "created_by": created_by,
      "category":category_id,
      "sub_category": sub_category_id,
       "user_role": user_role,
       "status" : status
    });
    return this.http.post<any>(`${this.apiURL}prompt_master_data/categories`, bodyRequest, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  data$ = this.dataSubject.asObservable();
  updateData(newData: boolean) {
    this.dataSubject.next(newData);
  }

  onRunPrompt(request:any) {
    const url = this.chatApiURL + 'manage-docs/upload-docs';
    const formData = new FormData();
    formData.append('question', request.question);
    formData.append('user_id', request.user_id?.toString());
    // formData.append('prompt_title', request.prompt_title);
    if(request.status){
      formData.append('prompt_id', request.prompt_id.toString());
      formData.append('is_draft_prompt', request.status === "DRAFT" ? 'true' : 'false'); 
    }else{
      if (request.prompt_id !== null && request.prompt_id !== undefined) {
        formData.append('prompt_id', request.prompt_id.toString());
        formData.append('is_draft_prompt', 'true'); 
      } else {
        formData.append('is_draft_prompt', 'false');
      }
    } 

    if(request?.project_code) {
      formData.append('project_code', request.project_code);
    }
    

    // if (request.permanentAttachments?.length) {
    //   request.permanentAttachments.forEach((permanentAttachment: any) => {
    //     if(permanentAttachment){
    //       formData.append('files', permanentAttachment);
    //     }
    //   })
    // }
    console.log("request.attachments", request.attachments);
    // if (request.attachments.length) {
    //   request.attachments.forEach((file: any) => {
    //     if(file){
    //       formData.append('files', file);
    //     }
    //   });
    // }
    // formData.append('prompt_id', request.prompt_id ? request.prompt_id?.toString(): null);
    // formData.append('is_draft_prompt', request.prompt_id ? 'true': 'false');
    formData.append('uploaded_files', JSON.stringify(request.uploaded_files));

    return this.http.post<any>(url,formData);
  }

  pollingApi(request: any) {
    const url = this.chatApiURL + 'manage-docs/get_selected_page_content';
    return this.http.post<any>(url,request);
  }

  executePrompt(request: any) {
    const url = this.apiURL + 'prompt_execution/execute';
    return this.http.post<any>(url,request);
  }

  OnSave(request:any) {
    const url = this.apiURL + 'prompt_manager/save_prompt';
    return this.http.post<any>(url,request);
  }

  OnSubmit(request:any) {
    const url = this.apiURL + 'prompt_manager/save_prompt';

    return this.http.post<any>(url,request);
  }

  // getPreSignedUrl(request: any) {
  //   const url = this.apiURL + 'attachments/get_pre_signed_url';
  //   return this.http.post<any>(url, request);
  // }

  getPresignedUrl(request:any): Observable<any> {
    const url = this.apiURL + 'attachments/get_pre_signed_url';
    return this.http.post(url,request);

    // return this.http.post<any>(url, JSON.stringify(request), {
    //   headers: {
    //     'Content-Type':'application/json'
    //   }
    // });
  }

  uploadFileToS3(url: string, file: File) {
    return this.http.put(url, file, {
      headers: {
        'Content-Type': '*'
      }
    });
  }

  getChats(request:any): Observable<any> {
    const url = this.chatApiURL + 'manage-chats/get-chats';
    return this.http.post(url,request);
  }

  onPromptBuilderAsk(request:any){
    const url = this.chatApiURL + 'prompt-builder/ask';
    return this.http.post<any>(url, request);
  }

  updateDocs(project_code:any){
    const url = this.chatApiURL + 'manage-docs/delete_folder_from_s3';
    return this.http.delete<any>(url+'?project_code='+project_code);
  }

  deleteChunks(project_code:any){
    const url = this.chatApiURL + 'manage-docs/delete_chunks_from_vector_store';
    return this.http.delete<any>(url+'?project_code='+project_code);
  }

  updateS3Names(data:any){
    const url = this.chatApiURL + 'manage-docs/rename_s3_folder';
    return this.http.post<any>(url, data);
  }

  updateDocsPrompt(data:any){
    const url = this.chatApiURL + 'manage-docs/update_docs_from_vector_store';
    return this.http.post<any>(url, data);
  }

  updateChatPrompt(data:any){
    const url = this.chatApiURL + 'manage-chats/update_chat';
    return this.http.put<any>(url, data);
  }

  onPromptBuilderAskStream(data: any): Observable<any> {
    const url = this.chatApiURL + 'prompt-builder/ask';  // Flask or FastAPI URL

    return new Observable((observer: Observer<any>) => {
      this.http.post(url, data, { responseType: 'text', observe: 'body' }).subscribe({
        next: (data) => {
 
          observer.next(data); // Send each new chunk to the observer
        },
        error: (error) => {
          observer.error(error);  // Handle error
        },
        complete: () => {
          observer.complete();  // Complete the stream
        }
      });
    });
  }

  fetchJsonStream(data: any) {
    const url = this.chatApiURL + 'prompt-builder/ask'; // Backend endpoint
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

  }

  getStoredAttachments(){
    return this.storedAttachments;
  }

  setStorredAttachmets(attachments:any){
    this.storedAttachments.push(...attachments);
  }

  // executePromptApiOld(data: any) {
  //   const token = localStorage.getItem('accessToken');
  //   const url = this.chatApiURL + 'prompt-builder/execute_prompt'; // Backend endpoint
  //   // return this.http.post(url,data);
  //   return fetch(url, {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': token ? `Bearer ${token}` : ''
  //     },
  //     body: JSON.stringify(data),
  //   });

  // }

  async executePromptApi(data: any): Promise<any> {
    const url = this.chatApiURL + 'prompt-builder/execute_prompt';

    try {
      const response = await firstValueFrom(
        this.http.post<any>(url, data, {
          headers: {
            'Content-Type': 'application/json'
            // Authorization header will be handled by interceptor
          }
        })
      );
      return response;
    } catch (err: any) {
      console.error('Error executing prompt:', err);
      throw new Error(`Error ${err.status || ''}: ${err.message || 'Unknown error'}`);
    }
  }

  // async getPromptAnswerApi1(data: any) {
  //   const token = localStorage.getItem('accessToken');
  //   // const url = this.chatApiURL + 'prompt-builder/asks'; // Backend endpoint
  //   const url = this.chatApiURL + 'prompt-builder/get_prompt_answer'; // Backend endpoint
  //   try {
  //     const response = await fetch(url, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': token ? `Bearer ${token}` : ''
  //       },
  //       body: JSON.stringify(data),
  //     });
  //     if (!response.ok) {
  //       // Check for specific error codes
  //       if (response.status === 502) {
  //         throw new Error('Bad Gateway: The server received an invalid response.');
  //       }
  //       throw new Error(`Try Error ${response.status}: ${response.statusText}`);
  //     }

  //     return response;
  //   } catch (err) {
  //     throw new Error(`Error catch ${err}`);
  //     // throw error; // Re-throw error to handle it further up the chain if needed
  //   }
  //   // return fetch(url, {
  //   //   method: 'POST',
  //   //   headers: {
  //   //     'Content-Type': 'application/json',
  //   //   },
  //   //   body: JSON.stringify(data),
  //   // });

  // }

  async getPromptAnswerApi(data: any): Promise<any> {
    const url = this.chatApiURL + 'prompt-builder/get_prompt_answer';

    try {
      const response = await firstValueFrom(
        this.http.post<any>(url, data, {
          headers: {
            'Content-Type': 'application/json'
            // No need to set Authorization manually — your interceptor will do it
          }
        })
      );
      
      return response;

    } catch (err: any) {
      console.error('Error fetching prompt answer:', err);
      if (err.status === 502) {
        throw new Error('Bad Gateway: The server received an invalid response.');
      }
      throw new Error(`Error ${err.status || ''}: ${err.message || 'Unknown error'}`);
    }
  }

  updateChatName(request:any): Observable<any> {
    const url = this.chatApiURL + 'manage-chats/update_chat';
    return this.http.put(url,request);
  }

  getChatsById(request:any): Observable<any> {
    const url = this.chatApiURL + 'manage-chats/get_chat_by_id';
    let getChatPayload = {
      'chat_id': request.chat_id,
      'messages_selected': request.messages_selected,
      'prompt_detail_version_id': request.prompt_detail_version_id,
      'prompt_id': request.prompt_id
    }

    return this.http.post<any>(url, JSON.stringify(getChatPayload), {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    // const url = this.chatApiURL + 'manage-chats/get_chat_by_id/'+request.id;
    // return this.http.get(url);
  }
}